export default {"src":"/_next/static/media/ecology.866a0c13.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};